import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { saveAs } from 'file-saver';

class BaseTicketingService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  public create(data) {
    return this.authHttp.post(APIURLConstantsService._API_BASE_URL + 'tickets', data)
    .pipe(map(response => response || {}));
  }

  public getActive(limit = 10, skip = 0, filters = {}, conds = {}, ordering = {}): Observable<any> {
    let params = new HttpParams();
    params = params.append('limit', limit.toString());
    params = params.append('skip', skip.toString());

    Object.keys(filters)
      .filter(filter => (filters[filter] === 0 || filters[filter]))
      .forEach(filter => params = params.append(filter, filters[filter].toString().replace(/\+/g,"%2B")));

    Object.keys(conds)
      .filter(cond => (conds[cond] === 0 || conds[cond]))
      .forEach(cond => params = params.append(cond, conds[cond].toString()));

    Object.keys(ordering).filter(field => (ordering[field] === 0 || ordering[field]))
    .forEach(field => params = params.append((ordering[field] === 'ASC' ? 'orderAsc' : 'orderDesc'), field));

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL  + 'tickets', this.options)
    .pipe(map(response => { return response || []; }));
  }

  public getAutocomplete(id: string): Observable<Array<{value: string, text: string}>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'autocomplete/' + id)
    .pipe(map(response => { return response || []; }));
  }

  public updateData(id: number, newData: any): Observable<any> {
    return this.authHttp.put(APIURLConstantsService._API_BASE_URL + 'tickets/' + id, newData)
    .pipe(map(response => response || {}));
  }

  public deleteData(id: number): Observable<any> {
    return this.authHttp.delete(APIURLConstantsService._API_BASE_URL + 'tickets/' + id)
      .pipe(map(response => response || {}));
  }


  constructor( protected authHttp: HttpClient, private validFilters, private validOrdering, private dateFields ) {}
}

@Injectable()
export class TicketingService extends BaseTicketingService {
  constructor(authHttp: HttpClient) {
    super(authHttp, [ 'id', 'tipus', 'subtipus', 'personal_id', 'data_acord', 'data_realitzacio' ], 
        [ 'tipus', 'subtipus', 'personal_id', 'data_acord', 'data_realitzacio' ],
        [ 'tipus', 'subtipus', 'personal_id', 'data_acord', 'data_realitzacio' ]);
  }
}
